var XMLNode = require("../xml/XMLNode");

/**
 * The Alignment class defines the alignment of content within the
 * sheet cells. The Alignment is assigned to a particular Style that
 * is registered in the Styles class.
 *
 * @constructor
 */
function Alignment() {
	XMLNode.call(this, Alignment.metadata);
}

Alignment.prototype = Object.create(XMLNode.prototype);
Alignment.prototype.constructor = Alignment;

Alignment.metadata = {
	tag: "alignment"
};

Alignment.horizontal = {
	LEFT: "left",
	CENTER: "center",
	RIGHT: "right",
	contains: function(sAlign) {

		return _contains(sAlign, Alignment.horizontal);
	}
};

Alignment.vertical = {
	TOP: "top",
	MIDDLE: "middle",
	BOTTOM: "bottom",
	contains: function(sAlign) {

		return _contains(sAlign, Alignment.vertical);
	}
};

/**
 * Checks whether the requested alignment is contained or not. An
 * alignment that is contained can be assigned within styles. Other
 * alignments that are not contained are not supported and thus not
 * assignable. It differentiates between horizontal and vertical
 * alignments, depending on the aggregation that was provided.
 *
 * @param {string} sAlign - The alignment that should be checked
 * @param {Array} oAggregation - The aggregation the alignment might be in
 * @returns {boolean} - Returns true if the alignment is supported
 * @private
 */
function _contains(sAlign, oAggregation) {
	var key, contained = false;

	for (key in oAggregation) {
		contained = contained ? contained : oAggregation[key] === sAlign && typeof oAggregation[key] !== "function";
	}

	return contained;
}

Alignment.prototype.isDefault = function() {
	return this.attributes.length == 0;
};

/**
 * Assigns the given indent to this Alignment object.
 *
 * @param {number} nIndent - Numerical value used as indentation
 */
Alignment.prototype.setIndent = function(nIndent) {

	/* Remove indent */
	if (typeof nIndent != "number" || nIndent <= 0) {
		this.remove("indent");

		return;
	}

	this._setAlignmentAttribute("indent", nIndent);

	/* A correct indent requires an explicit horizontal alignment */
	if (!this.horizontal) {
		this.setHorizontalAlignment(Alignment.horizontal.LEFT);
	}
};


/**
 * Configures the wrapText attribute of the alignment which is used
 * for multiline text support.
 *
 * @param {boolean} bWrap - Defines if wrapping is enabled or disabled
 */
Alignment.prototype.setWrapText = function(bWrap) {
	var wrappingAttribute = "wrapText";


	if (bWrap) {
		this._setAlignmentAttribute(wrappingAttribute, "1");

		return;
	}

	if (this[wrappingAttribute]) {
		this.remove(wrappingAttribute);
	}
};

/**
 * Applies the given alignment as horizontal alignment.
 *
 * @param {string} sAlign - Horizontal alignment that gets applied
 */
Alignment.prototype.setHorizontalAlignment = function(sAlign) {

	/* Ignore invalid values */
	if (!Alignment.horizontal.contains(sAlign)) {
		return;
	}

	this._setAlignmentAttribute("horizontal", sAlign);
};

/**
 * Applies the given alignment as vertical alignment.
 *
 * @param {string} sAlign - Vertical alignment that gets applied
 */
Alignment.prototype.setVerticalAlignment = function(sAlign) {

	/* Ignore invalid values */
	if (!Alignment.vertical.contains(sAlign)) {
		return;
	}

	this._setAlignmentAttribute("vertical", sAlign);
};

/**
 * Assigns the given value as a named property on this Alignment object.
 *
 * @param {string} sId - The named property id
 * @param {number|string} value - Textual or numerical value
 * @private
 */
Alignment.prototype._setAlignmentAttribute = function(sId, value) {

	/* Create attribute if not present */
	if (!this[sId]) {
		this.addAttribute({
			id: sId,
			name: sId
		});
	}

	this[sId].value = value;
};

/**
 * Access the given alignment attribute and return its value. This is a shorthand
 * function to access the value without having to check for the existence of the
 * attribute itself.
 *
 * @param {string} sId - Alignment attribute that will be returned
 * @return {string|number} - value of the given alignment attribute
 * @private
 */
Alignment.prototype._getAlignmentAttribute = function(sId) {
	return this[sId] && this[sId].value;
};

Alignment.prototype.equals = function(oAlignment) {
	return typeof oAlignment !== "undefined" && oAlignment !== null
		&& this._getAlignmentAttribute("vertical") == oAlignment._getAlignmentAttribute("vertical")
		&& this._getAlignmentAttribute("horizontal") == oAlignment._getAlignmentAttribute("horizontal")
		&& this._getAlignmentAttribute("indent") == oAlignment._getAlignmentAttribute("indent")
		&& this._getAlignmentAttribute("wrapText") == oAlignment._getAlignmentAttribute("wrapText");
};

module.exports = Alignment;